import { $api } from 'api/http'
import { ICategory } from 'api/types/category'

class CategoryApiService {
  getCategories() {
    return $api.get<Array<ICategory>>('/categories')
  }
}

export const categoryApiService = new CategoryApiService()
